export default __webpack_public_path__ + "static/media/jadwal-raffle-green.ac30c875.png";